import { Routes, Route } from 'react-router-dom';
import MainPage from './Pages/MainPage';
import LegalPage from './Pages/LegalPage'
import PortfolioPage from './Pages/PortfolioPage'
import JourneyPage from './Pages/JourneyPage'
import AboutPage from './Pages/AboutPage'
import './tailwind.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/journey" element={<JourneyPage />} />
    </Routes>
  );
}

export default App;
